import React from "react";
import Header from "./Reusables/Header";
import RBMTable from "./Tables/RBMTable";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadImg from "../assests/download.svg";
import PeriodSelector from "./PeriodSelector";
const RBMlevelBudget = () => {




  return (
    <div className="bg-white home-screen">
     
     <PeriodSelector/>

      <RBMTable style={{ marginTop: "20px", marginRight: "10px",height:"100vh" }} />
    
    </div>
  );
};

export default RBMlevelBudget;
